import { SET_COOKIES_MODAL } from '../../constants/actions';

const initialState = {
  showCookiesModal: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_COOKIES_MODAL:
      return {
        showCookiesModal: action.data,
      };
    default:
      return state;
  }
}
